<template>
  <div :class="`font-sans antialiased text-neutrals-text leading-normal tracking-wider bg-neutrals-surface`">
    <header class="bg-neutrals-background shadow-md sticky top-0 z-30">
      <div class="px-6 py-4 flex items-center justify-between">
        <!--<a href="" :class="`flex items-center text-2xl font-bold text-secondary`">
          <span class="hidden sm:inline">Varanda Imóveis RP</span>
        </a>-->
        <img src="/logo.png" class="h-20 w-auto" />

        <div class="lg:hidden">
          <button @click="toggleMobileMenu" :class="`text-neutrals-muted hover:text-secondary focus:outline-none`">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>

        <nav class="hidden lg:block">
          <ul class="flex items-center space-x-6 text-lg">
            <li>
              <router-link :to="{ name: 'HomePage', query: { op: 'rent' } }"
                :class="`text-neutrals-muted hover:text-secondary transition duration-300`">Alugar</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'HomePage', query: { op: 'sale' } }"
                :class="`text-neutrals-muted hover:text-secondary transition duration-300`">Comprar</router-link>
            </li>
            <li>
              <a href="#loteamentos"
                :class="`text-neutrals-muted hover:text-secondary transition duration-300`">Lançamentos</a>
            </li>
            <li>
              <router-link to="/cadastre-seu-imovel" target="_blank"
                :class="`bg-primary text-white font-semibold py-2 px-5 rounded-full transition-all duration-300 hover:bg-primary shadow-lg`">
                Cadastre seu Imóvel
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div v-if="isMobileMenuOpen"
        class="lg:hidden absolute inset-x-0 top-0 mt-16 p-4 bg-neutrals-background shadow-lg rounded-b-lg">
        <ul class="flex flex-col space-y-4 text-center">
          <li>
            <a href="#" :class="`text-neutrals-muted hover:text-secondary transition duration-300`"
              @click="toggleMobileMenu">Alugar</a>
          </li>
          <li>
            <a href="#" :class="`text-neutrals-muted hover:text-secondary transition duration-300`"
              @click="toggleMobileMenu">Comprar</a>
          </li>
          <li>
            <a href="#loteamentos" :class="`text-neutrals-muted hover:text-secondary transition duration-300`"
              @click="toggleMobileMenu">Lançamentos</a>
          </li>
          <li>
            <router-link to="/cadastre-seu-imovel" target="_blank"
              :class="`block w-full bg-primary text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 hover:bg-primary shadow-lg`"
              @click="toggleMobileMenu">
              Cadastre seu Imóvel
            </router-link>
          </li>
        </ul>
      </div>
    </header>

    <section class="relative bg-cover bg-center h-96" style="background-image: url('banner.jpeg');">
      <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      <div class="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-4">
        <h1 class="text-5xl md:text-6xl font-extrabold mb-4 drop-shadow-lg">
          Encontre aqui o seu <span :class="`text-primary text-shadow-white`">Imóvel</span>
        </h1>
        <p class="text-lg md:text-xl opacity-90">Lançamentos, casas, apartamentos e terrenos em um só lugar</p>
      </div>
    </section>

    <section class="relative -mt-16 z-20">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          :class="`bg-neutrals-background p-6 md:p-8 rounded-2xl shadow-xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4`">

          <div>
            <label :class="`block text-sm font-medium text-neutrals-muted mb-1`">Operação</label>
            <select v-model="form.operation"
              :class="`w-full h-12 px-3 border border-gray-300 rounded-md shadow focus:ring focus:ring-secondary focus:border-secondary transition`">
              <option value="" disabled selected>Selecione</option>
              <option v-for="op in options.operation" :key="op.value" :value="op.value">{{ op.label }}</option>
            </select>
          </div>

          <div>
            <label :class="`block text-sm font-medium text-neutrals-muted mb-1`">Cidade</label>
            <select v-model="form.city"
              :class="`w-full h-12 px-3 border border-gray-300 rounded-md shadow focus:ring focus:ring-secondary focus:border-secondary transition`">
              <option value="" disabled selected>Selecione</option>
              <option v-for="c in options.cities" :key="c.value" :value="c.value">{{ c.label }}</option>
            </select>
          </div>

          <div>
            <label :class="`block text-sm font-medium text-neutrals-muted mb-1`">Tipo</label>
            <select v-model="form.type"
              :class="`w-full h-12 px-3 border border-gray-300 rounded-md shadow focus:ring focus:ring-secondary focus:border-secondary transition`">
              <option value="" disabled selected>Selecione</option>
              <option v-for="t in options.types" :key="t.value" :value="t.value">{{ t.label }}</option>
            </select>
          </div>

          <div>
            <label :class="`block text-sm font-medium text-neutrals-muted mb-1`">Dormitórios</label>
            <select v-model="form.bedrooms"
              :class="`w-full h-12 px-3 border border-gray-300 rounded-md shadow focus:ring focus:ring-secondary focus:border-secondary transition`">
              <option value="" disabled selected>Selecione</option>
              <option v-for="b in options.bedrooms" :key="b.value" :value="b.value">{{ b.label }}</option>
            </select>
          </div>

          <div class="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label :class="`block text-sm font-medium text-neutrals-muted mb-1`">Preço Mínimo</label>
              <div
                :class="`relative flex items-center h-12 border border-gray-300 rounded-md shadow focus-within:ring focus-within:ring-secondary focus-within:border-secondary transition`">
                <input type="text" v-model="form.priceMinFormatted" placeholder="Mínimo"
                  @input="formatCurrencyInput('priceMin')"
                  class="w-full h-full pl-9 pr-3 text-right bg-transparent focus:outline-none" />
              </div>
            </div>
            <div>
              <label :class="`block text-sm font-medium text-neutrals-muted mb-1`">Preço Máximo</label>
              <div
                :class="`relative flex items-center h-12 border border-gray-300 rounded-md shadow focus-within:ring focus-within:ring-secondary focus-within:border-secondary transition`">
                <input type="text" v-model="form.priceMaxFormatted" placeholder="Máximo"
                  @input="formatCurrencyInput('priceMax')"
                  class="w-full h-full pl-9 pr-3 text-right bg-transparent focus:outline-none" />
              </div>
            </div>
          </div>

          <div class="lg:col-span-1 flex items-end gap-2">
            <button @click="resetFilters"
              :class="`w-full h-12 bg-neutrals-surface text-neutrals-text font-semibold rounded-xl shadow hover:bg-gray-200 transition`">
              Limpar
            </button>
            <button @click="search"
              :class="`w-full h-12 bg-primary text-white font-semibold rounded-xl shadow hover:bg-primary transition flex items-center justify-center gap-2`">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z" />
              </svg>
              Pesquisar
            </button>
          </div>
        </div>
      </div>
    </section>

    <section :class="`max-w-full px-4 sm:px-6 lg:px-8 py-12 bg-neutrals-background`">
      <h2 :class="`text-3xl font-bold text-neutrals-text mb-8 text-center`" data-aos="fade-up" data-aos-duration="800">
        Imóveis em Destaque</h2>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div v-for="(property, index) in regularProperties" :key="property.id"
          :class="`bg-neutrals-background rounded-2xl shadow-lg overflow-hidden border border-transparent hover:border-secondary hover:shadow-2xl transition-all duration-300 ease-in-out`"
          data-aos="zoom-in" data-aos-duration="800" :data-aos-delay="index * 0">

          <div class="relative mb-8">

            <v-carousel :continuous="false" :show-arrows="true" :show-delimiters="true" height="280"
              hide-delimiter-background class="cardPropertyCarousel" :cycle="false">

              <v-carousel-item v-for="(img, i) in property.images" :key="i" class="relative">
                <v-img :src="img" class="w-full h-full object-cover" cover>

                  <div
                    :class="`absolute top-2 left-2 bg-primary/70 backdrop-blur-sm text-white text-[10px] font-bold py-0.5 px-2 rounded-md uppercase z-10`">
                    {{ formatOperation(property.operation) }}
                  </div>
                  <div v-if="property.is_reserved"
                    :class="`absolute top-2 right-2 bg-states-error/70 backdrop-blur-sm text-white text-[10px] font-bold py-0.5 px-2 rounded-md uppercase z-10`">
                    Reservado
                  </div>

                </v-img>
              </v-carousel-item>
            </v-carousel>
          </div>

          <router-link :to="{ name: 'detalhes', params: { slug: property.slug } }" class="block">
            <div class="p-3 flex flex-col h-full">
              <div class="flex justify-between items-center mb-2">
                <p :class="`text-xs text-neutrals-muted`">Cód: {{ formatCode(property) }}</p>
                <p :class="`text-xs text-neutrals-muted capitalize`">{{ formatType(property.type) }}</p>
              </div>
              <h3 :class="`text-xl font-extrabold text-neutrals-text mb-4 leading-tight`">
                {{ property.title }}
              </h3>
              <p :class="`text-sm text-neutrals-muted font-medium mb-4 flex items-center gap-1`">
                <svg :class="`w-4 h-4 text-neutrals-muted`" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {{ property.neighborhood }}, {{ property.city }} - {{ property.state }}
              </p>

              <div :class="[
                'flex items-center mt-5',
                'text-neutrals-muted',
                {
                  'justify-center gap-6': getCharacteristicsCount(property) <= 2,
                  'justify-between': getCharacteristicsCount(property) > 2
                }
              ]">
                <div class="flex flex-wrap gap-2 mb-3">
                  <div v-if="property.area > 0"
                    :class="`flex items-center gap-1 bg-neutrals-surface text-neutrals-text px-2 py-1 rounded-full text-xs font-medium`">
                    <img :src="areaUIcon" alt="Ícone de Área" class="w-4 h-4" />
                    <span>{{ property.area }} m²</span>
                  </div>
                  <div v-if="property.bedrooms > 0"
                    :class="`flex items-center gap-1 bg-neutrals-surface text-neutrals-text px-2 py-1 rounded-full text-xs font-medium`">
                    <img :src="dormitoriosIcon" alt="Ícone de Dormitórios" class="w-4 h-4" />
                    <span>{{ property.bedrooms }}</span>
                  </div>
                  <div v-if="property.suites > 0"
                    :class="`flex items-center gap-1 bg-neutrals-surface text-neutrals-text px-2 py-1 rounded-full text-xs font-medium`">
                    <img :src="suitesIcon" alt="Ícone de Suítes" class="w-4 h-4" />
                    <span>{{ property.suites }}</span>
                  </div>
                  <div v-if="property.bathrooms > 0"
                    :class="`flex items-center gap-1 bg-neutrals-surface text-neutrals-text px-2 py-1 rounded-full text-xs font-medium`">
                    <img :src="banheirosIcon" alt="Ícone de Banheiros" class="w-4 h-4" />
                    <span>{{ property.bathrooms }}</span>
                  </div>
                  <div v-if="property.garage > 0"
                    :class="`flex items-center gap-1 bg-neutrals-surface text-neutrals-text px-2 py-1 rounded-full text-xs font-medium`">
                    <img :src="garagensIcon" alt="Ícone de Garagem" class="w-4 h-4" />
                    <span>{{ property.garage }}</span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between items-center pt-3 border-t">
                <span :class="`text-lg font-extrabold text-secondary`">{{ formatCurrency(property.price) }}</span>
                <a :href="getWhatsappLink(property)" target="_blank" @click.stop
                  :class="`hover:bg-secondary/10 p-2 rounded-full duration-300`">
                  <svg class="w-6 h-6 text-states-success" fill="currentColor" viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 0C7.164 0 0 7.163 0 16c0 2.82.736 5.556 2.137 7.972L.053 32l8.238-2.157A15.91 15.91 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0Zm0 29.5c-2.617 0-5.163-.688-7.388-1.992l-.529-.312-4.884 1.279 1.303-4.766-.344-.563A13.45 13.45 0 0 1 2.5 16c0-7.457 6.043-13.5 13.5-13.5S29.5 8.543 29.5 16 23.457 29.5 16 29.5Z" />
                    <path
                      d="M23.155 18.726c-.39-.195-2.31-1.14-2.67-1.27-.36-.132-.622-.195-.885.195-.263.39-1.017 1.27-1.248 1.533-.23.263-.46.293-.85.098-.39-.195-1.647-.607-3.137-1.936-1.16-1.033-1.942-2.31-2.172-2.7-.23-.39-.025-.6.17-.795.174-.174.39-.46.585-.69.195-.23.26-.39.39-.65.132-.263.066-.488-.033-.683-.098-.195-.885-2.136-1.213-2.93-.32-.77-.647-.665-.885-.675-.23-.01-.49-.012-.75-.012s-.682.098-1.04.488c-.36.39-1.37 1.338-1.37 3.26s1.404 3.785 1.6 4.05c.195.263 2.767 4.23 6.71 5.927.938.404 1.67.646 2.24.826.94.3 1.793.258 2.468.157.753-.112 2.31-.943 2.636-1.852.325-.91.325-1.693.23-1.852-.098-.16-.355-.263-.745-.458Z" />
                  </svg>
                </a>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- PAGINAÇÃO -->
      <div v-if="propertyHasMore" class="text-center mt-8 mb-10">
        <button @click="getRegularProperties(true)"
          class="px-6 py-2 bg-primary text-white text-lg rounded-full shadow hover:bg-primary/80 transition">
          Ver mais imóveis
        </button>
      </div>
    </section>

    <!-- SEÇÃO DE LOTEAMENTOS -->
    <section id="loteamentos" v-if="launchProperties.length > 0"
      :class="`max-w-full px-4 sm:px-6 lg:px-8 py-20 bg-gradient-to-br from-primary/20 to-secondary/20`">
      <div class="text-center mb-12" data-aos="fade-up" data-aos-duration="800">
        <h2 class="text-4xl font-extrabold text-primary mb-3">
          Lançamentos em Destaque
        </h2>
        <p class="text-lg text-gray-700 max-w-2xl mx-auto">
          Confira nossos lançamentos mais recentes e garanta um ótimo negócio.
        </p>
      </div>

      <v-card class="mx-auto rounded-3xl shadow-2xl" elevation="10" :style="{ maxHeight: '550px' }">
        <v-carousel v-if="launchProperties && launchProperties.length > 0" v-model="activeLotIndex" :continuous="true"
          :show-arrows="false" :show-delimiters="true" hide-delimiter-background :cycle="false" height="550"
          class="lotsCarousel">
          <v-carousel-item v-for="(lot, index) in launchProperties" :key="lot.id">

            <LotImagePlayer :images="lot.images" :title="lot.title" :is-active="index === activeLotIndex"
              @navigate="handleNavigation">
              <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>

              <div
                class="absolute bottom-0 left-0 right-0 p-8 text-white flex flex-col md:flex-row md:items-end md:justify-between gap-6 z-20">
                <div>
                  <p class="text-sm text-gray-200 mb-1">Cód: {{ formatCode(lot) }}</p>
                  <h3 class="text-3xl font-bold leading-tight mb-2">{{ lot.title }}</h3>
                  <p class="text-lg font-medium text-gray-200 mb-2">{{ lot.city }} - {{ lot.state }}</p>
                  <p v-if="lot.price > 0" class="text-4xl font-extrabold text-accent">
                    {{ formatCurrency(lot.price) }}
                  </p>
                </div>

                <v-btn :href="getWhatsappLinkLaunch(lot)" target="_blank" color="primary" size="large" rounded="xl"
                  class="font-semibold shadow-lg hover:bg-secondary-darken-1 transition-all duration-300"
                  prepend-icon="mdi-whatsapp">
                  Falar no WhatsApp
                </v-btn>
              </div>
            </LotImagePlayer>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </section>

    <!--<section :class="`py-16 bg-neutrals-surface`">
      <div class="container mx-auto px-6 max-w-7xl">
        <div class="text-center mb-12" data-aos="fade-up">
          <h2 :class="`text-4xl font-extrabold text-neutrals-text`">
            Clique e assista nossos <span :class="`text-secondary`">Vídeos</span>
          </h2>
          <p :class="`mt-4 text-xl text-neutrals-muted`">
            Conheça mais sobre os imóveis, o mercado e dicas de investimento.
          </p>
        </div>

        <div v-if="videos && videos.length > 0" data-aos="zoom-in" data-aos-delay="100">

          <div :class="{
            'flex justify-center': videos.length <= 2,
            'w-full': videos.length > 2
          }">
            <v-slide-group show-arrows center-active mandatory
              :style="videos.length <= 2 ? 'flex-grow: 0;' : 'flex-grow: 1;'"
              :class="{ 'max-w-full': videos.length <= 2 }">

              <v-slide-group-item v-for="(v, index) in videos" :key="index">

                <v-card :class="`mx-2 rounded-2xl overflow-hidden shadow-2xl flex-shrink-0`"
                  :width="$vuetify.display.lgAndUp ? '380px' : $vuetify.display.smAndUp ? '300px' : '90vw'">

                  <div class="relative" style="padding-top: 56.25%;">
                    <iframe class="absolute top-0 left-0 w-full h-full" :src="v.video_url_embed" :title="v.title"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-m*edia; gyroscope; picture-in-picture"
                      allowfullscreen>
                    </iframe>
                  </div>
                </v-card>
              </v-slide-group-item>
            </v-slide-group>
          </div>
        </div>

        <div v-else :class="`text-center py-8 text-neutrals-muted`">
          <p>Nenhum vídeo disponível no momento.</p>
        </div>
      </div>
    </section>-->

    <section :class="`py-16 bg-neutrals-background`">
      <div class="container mx-auto px-6 max-w-7xl">
        <h2 :class="`text-3xl font-bold text-center mb-12 text-neutrals-text`" data-aos="fade-up">
          Nossa Equipe de <span :class="`text-secondary`">Consultores</span>
        </h2>

        <div v-if="brokers && brokers.length > 0">
          <div :class="{
            'flex justify-center': brokers.length <= 3,
            'w-full': brokers.length > 3
          }">
            <v-slide-group show-arrows center-active :style="brokers.length <= 3 ? 'flex-grow: 0;' : 'flex-grow: 1;'"
              :class="{ 'max-w-full': brokers.length <= 3 }">

              <v-slide-group-item v-for="(broker, index) in brokers" :key="index">
                <v-card :width="$vuetify.display.mdAndUp ? '280px' : '90vw'"
                  :class="`mx-4 rounded-2xl shadow-lg overflow-hidden border transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-2xl hover:z-10 flex-shrink-0`"
                  data-aos="zoom-in" :data-aos-delay="index * 100">

                  <div class="relative">
                    <v-img :src="broker.image" alt="Foto do Corretor" cover height="256">
                      <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div class="absolute bottom-0 left-0 p-4 text-white w-full">
                        <div v-if="broker.is_plantao"
                          :class="`absolute top-0 right-0 -mt-3 mr-3 bg-secondary text-white text-xs font-bold py-1 px-3 rounded-full uppercase shadow-md -rotate-3`">
                          Plantonista
                        </div>
                        <h3 class="text-xl font-bold drop-shadow-lg">{{ broker.name }}</h3>
                        <p class="text-sm opacity-80 mt-1">CRECI {{ broker.creci }}</p>
                      </div>
                    </v-img>
                  </div>

                  <div :class="`p-4 bg-neutrals-surface flex justify-center`">
                    <a :href="broker.is_plantao ? `https://api.whatsapp.com/send?phone=${broker.phone}` : '#'"
                      :target="broker.is_plantao ? '_blank' : null" :class="{
                        'text-neutrals-text hover:text-secondary': broker.is_plantao,
                        'text-neutrals-muted cursor-not-allowed': !broker.is_plantao
                      }" class="flex items-center gap-2 transition-colors duration-300">
                      <svg class="w-6 h-6"
                        :class="{ 'text-states-success': broker.is_plantao, 'text-neutrals-muted': !broker.is_plantao }"
                        fill="currentColor" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16 0C7.164 0 0 7.163 0 16c0 2.82.736 5.556 2.137 7.972L.053 32l8.238-2.157A15.91 15.91 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0Zm0 29.5c-2.617 0-5.163-.688-7.388-1.992l-.529-.312-4.884 1.279 1.303-4.766-.344-.563A13.45 13.45 0 0 1 2.5 16c0-7.457 6.043-13.5 13.5-13.5S29.5 8.543 29.5 16 23.457 29.5 16 29.5Z" />
                        <path
                          d="M23.155 18.726c-.39-.195-2.31-1.14-2.67-1.27-.36-.132-.622-.195-.885.195-.263.39-1.017 1.27-1.248 1.533-.23.263-.46.293-.85.098-.39-.195-1.647-.607-3.137-1.936-1.16-1.033-1.942-2.31-2.172-2.7-.23-.39-.025-.6.17-.795.174-.174.39-.46.585-.69.195-.23.26-.39.39-.65.132-.263.066-.488-.033-.683-.098-.195-.885-2.136-1.213-2.93-.32-.77-.647-.665-.885-.675-.23-.01-.49-.012-.75-.012s-.682.098-1.04.488c-.36.39-1.37 1.338-1.37 3.26s1.404 3.785 1.6 4.05c.195.263 2.767 4.23 6.71 5.927.938.404 1.67.646 2.24.826.94.3 1.793.258 2.468.157.753-.112 2.31-.943 2.636-1.852.325-.91.325-1.693.23-1.852-.098-.16-.355-.263-.745-.458Z" />
                      </svg>
                      <span class="font-medium">Falar com {{ broker.name }}</span>
                    </a>
                  </div>
                </v-card>
              </v-slide-group-item>
            </v-slide-group>
          </div>
        </div>

        <!--<div v-else :class="`text-center py-8 text-neutrals-muted`">
          <p>Nenhum consultor disponível no momento.</p>
        </div>-->
      </div>
    </section>

    <!--<section :class="`bg-neutrals-surface py-12`">
      <div class="container mx-auto px-6 max-w-7xl">
        <div
          :class="`flex flex-col md:flex-row items-center justify-between p-8 rounded-2xl shadow-xl bg-gradient-to-r from-secondary to-primary text-white`"
          data-aos="fade-up">
          <div class="flex items-center mb-6 md:mb-0">
            <svg xmlns="http://www.w3.org/2000/svg" :class="`w-12 h-12 mr-6 text-secondary/50`" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <div class="text-center md:text-left">
              <h3 class="text-2xl font-bold">Atendimento Personalizado</h3>
              <p :class="`text-white/80 mt-2`">Veja nossos horários de funcionamento e agende uma visita.</p>
            </div>
          </div>
          <router-link to="/horarios"
            :class="`px-8 py-3 bg-white text-secondary font-bold rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300`">
            Ver Horários
          </router-link>
        </div>
      </div>
    </section>-->

    <ContactForm />

    <AppFooter />
    <Copyright />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, provide } from 'vue';
import { RouterLink } from 'vue-router';
import api from '@/services/api';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useRoute } from 'vue-router';
import { PALETTE } from '@/constants/colors';

import AppFooter from '@/components/AppFooter.vue';
import Copyright from '@/components/Copyright.vue';
import ContactForm from '@/components/ContactForm.vue';

import dormitoriosIcon from '@/assets/icones/dormitorios.svg';
import suitesIcon from '@/assets/icones/suites.svg';
import banheirosIcon from '@/assets/icones/banheiros.svg';
import garagensIcon from '@/assets/icones/garagens.svg';
import areaUIcon from '@/assets/icones/area_u.svg';
import whatsappIcon from '@/assets/icones/whatsapp.svg';

import LotImagePlayer from './LotImagePlayer.vue';

const route = useRoute();
const scrollContainer = ref(null);
let isDragging = false;
let startX;
let scrollLeft;
const isMobileMenuOpen = ref(false);
const properties = ref([]);
const regularPropertiesData = ref([]);
const launchPropertiesData = ref([]);
const displayedProperties = ref([]);
const brokers = ref([]);
const app_url_api_storage = process.env.VUE_APP_URL_API_STORAGE;
const enterprisePhone = ref(null);
const enterpriseName = ref(null);
const videos = ref([]);
const activeLotIndex = ref(0);
const propertyHasMore = ref(false)
const perPage = 12;
const page = ref(1);
const enterprise = ref({});
const ENTERPRISE_KEY = 'enterpriseData';

function handleNavigation(direction) {
  const totalLots = launchProperties.value.length;
  let newIndex = activeLotIndex.value;

  if (direction === 'prev') {
    newIndex = (newIndex - 1 + totalLots) % totalLots;
  } else if (direction === 'next') {
    newIndex = (newIndex + 1) % totalLots;
  }

  // Atualiza o v-model do carrossel para mudar o imóvel
  activeLotIndex.value = newIndex;
}

const enterpriseDataToProvide = computed(() => enterprise.value);
provide(ENTERPRISE_KEY, enterpriseDataToProvide);

function initializeFormFromRoute() {
  const operationParam = route.query.op;
  const validOperations = ['rent', 'sale', 'launch'];

  if (operationParam && validOperations.includes(operationParam)) {
    form.value.operation = operationParam;
  } else {
    form.value.operation = null;
  }
}

onMounted(async () => {
  AOS.init({
    duration: 1000,
    once: true,
  });

  const container = scrollContainer.value;

  if (container) {
    container.addEventListener('mousedown', (e) => {
      isDragging = true;
      container.classList.add('active');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      isDragging = false;
      container.classList.remove('active');
    });

    container.addEventListener('mouseup', () => {
      isDragging = false;
      container.classList.remove('active');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    });
  }

  await getEnterprise();
  await getRegularProperties();
  await getLaunchProperties();
  await getBrokers();
  //await getVideos();

  initializeFormFromRoute();


});

watch(() => route.query.op, () => {
  initializeFormFromRoute();
});

async function getEnterprise() {
    try {
        const response = await api.get('/enterprise');
        // Armazena todos os dados
        const enterpriseData = response.data.data[0]; 
        
        // Formata o telefone e armazena
        enterprise.value = {
            ...enterpriseData,
            phoneFormatted: formatPhone(enterpriseData.phone) 
        };
        
    } catch (error) {
        console.error('Erro ao buscar empresa:', error);
    }
}

async function getRegularProperties(loadMore = false) {
  try {
    if (loadMore) {
      page.value++;
    } else {
      page.value = 1;
      regularPropertiesData.value = [];
    }

    const response = await api.get('/properties', {
      params: {
        page: page.value,
        per_page: perPage,
        is_launch: 0,
      }
    });

    const apiData = response.data;
    const newProperties = apiData.data.map(property => ({
      ...property,
      images: property.images ? property.images.map(img => `${app_url_api_storage}/images/${img}`) : []
    }));

    if (loadMore) {
      regularPropertiesData.value = [...regularPropertiesData.value, ...newProperties];
    } else {
      regularPropertiesData.value = newProperties;
    }

    propertyHasMore.value = apiData.page < apiData.lastPage;

  } catch (error) {
    console.error('Erro ao buscar imóveis regulares:', error);
  }
}

async function getLaunchProperties() {
  try {
    const response = await api.get('/properties', {
      params: {
        is_launch: 1,
        per_page: -1,
      }
    });

    const apiData = response.data;
    const launchData = apiData.data.map(property => ({
      ...property,
      images: property.images ? property.images.map(img => `${app_url_api_storage}/images/${img}`) : []
    }));

    launchPropertiesData.value = launchData;

  } catch (error) {
    console.error('Erro ao buscar lançamentos:', error);
  }
}

async function getBrokers() {
  try {
    const response = await api.get('/brokers', {
      params: { is_active: 1, role: ['broker', 'adminbroker'] }
    });

    const brokerData = response.data.data;

    if (brokerData) {
      brokers.value = brokerData.map(broker => {
        return {
          ...broker,
          image: broker.image_url ? `${app_url_api_storage}/images/${broker.image_url}` : ''
        };
      });
    }
  } catch (error) {
    console.error('Erro ao buscar corretores:', error);
  }
}

async function getVideos() {
  try {
    const response = await api.get('/video', {
      params: { is_active: 1, type: 'external' }
    });
    console.log(response.data.data)
    videos.value = response.data.data;
  } catch (error) {
    console.error('Erro ao buscar corretores:', error);
  }
}

const launchProperties = computed(() => {
    return launchPropertiesData.value.filter(property => {
        return true; 
    });
});

const regularProperties = computed(() => {
    return regularPropertiesData.value.filter(property => {
        return true;
    });
});

function search() {
    getRegularProperties(false);
    getLaunchProperties();
}

function toggleMobileMenu() {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
}

const form = ref({
  operation: null,
  city: null,
  type: null,
  bedrooms: null,
  priceMin: null,
  priceMax: null,
  priceMinFormatted: null,
  priceMaxFormatted: null,
});

function resetFilters() {
  form.value.operation = null;
  form.value.city = null;
  form.value.type = null;
  form.value.bedrooms = null;
  form.value.priceMax = null,
    form.value.priceMin = null;
  form.value.priceMinFormatted = null;
  form.value.priceMaxFormatted = null;
  displayedProperties.value = properties.value;
}

const options = ref({
  operation: [
    { label: 'Alugar', value: 'rent' },
    { label: 'Comprar', value: 'sale' },
    { label: 'Lançamentos', value: 'launch' },
  ],
  cities: [
  ],
  types: [
    { label: 'Casa', value: 'house' },
    { label: 'Apartamento', value: 'apartment' },
    { label: 'Terreno', value: 'land' },
    { label: 'Rural', value: 'rural' },
    { label: 'Comercial', value: 'commercial' },
  ],
  bedrooms: [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4+', value: 4 },
  ],
});

function groupBy(array, key) {
  return array.reduce((acc, item) => {
    const groupKey = item[key];
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(item);
    return acc;
  }, {});
}

const isOperationLocked = computed(() => {
  return !!form.value.operation;
});

function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

function getCharacteristicsCount(property) {
  let count = 0;
  if (property.area > 0) count++;
  if (property.bedrooms > 0) count++;
  if (property.suites > 0) count++;
  if (property.bathrooms > 0) count++;
  if (property.garage > 0) count++;
  return count;
}

function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
}

function getWhatsappLink(property) {
  const phone = enterprisePhone.value || enterprise.value.whatsapp;

  const phoneNumberCleaned = phone ? phone.replace(/[()\s-.]/g, '') : null;
  const message = `Olá,

Obrigado pelo seu interesse no imóvel de código ${formatCode(property)}, localizado em ${property.neighborhood}, ${property.city} - ${property.state}. Eu sou da ${enterpriseName.value} e vou atender você.

O que você gostaria de saber e em que posso ajudar?

Abraço!

Atenciosamente, 
Sheila Magaly Santana 
Tel/Whatsapp: ${formatPhone(phone)}.`;


  if (phoneNumberCleaned) {
    return `https://api.whatsapp.com/send?phone=${phoneNumberCleaned}&text=${encodeURIComponent(message)}`;
  }

  return '#';
}

function getWhatsappLinkLaunch(property) {
  const phone = enterprisePhone.value || enterprise.value.whatsapp;

  const phoneNumberCleaned = phone ? phone.replace(/[()\s-.]/g, '') : null;
  const message = `Olá,

Obrigado pelo seu interesse no lançamento de código ${formatCode(property)}, localizado em ${property.neighborhood}, ${property.city} - ${property.state}. Eu sou da ${enterpriseName.value} e vou atender você.

O que você gostaria de saber e em que posso ajudar?

Abraço!

Atenciosamente, 
Sheila Magaly Santana 
Tel/Whatsapp: ${formatPhone(phone)}.`;


  if (phoneNumberCleaned) {
    return `https://api.whatsapp.com/send?phone=${phoneNumberCleaned}&text=${encodeURIComponent(message)}`;
  }

  return '#';
}

function formatOperation(operation) {
  switch (operation) {
    case 'rent':
      return 'Locação';
    case 'sale':
      return 'Venda';
    case 'launch':
      return 'Lançamento';
    case 'both':
      return 'Venda e Locação';
    default:
      return operation;
  }
}

function formatType(type) {
  switch (type) {
    case 'apartment':
      return 'Apartamento';
    case 'house':
      return 'Casa';
    case 'land':
      return 'Terreno';
    case 'rural':
      return 'Rural';
    case 'commercial':
      return 'Comercial';
    default:
      return type;
  }
}

function formatCode(property) {
  let code = null;
  if (property.operation === 'rent') {
    code = 'L-';
  } else if (property.operation === 'sale') {
    code = 'V-';
  }
  else if (property.operation === 'launch') {
    code = 'LA-';
  }
  else if (property.operation === 'both') {
    code = 'VL-';
  } else {
    code = '';
  }

  code = code + property.id + '-' + property.year;

  return code;
}

function formatCurrencyInput(field) {
  const value = form.value[field + 'Formatted'];
  const clean = (value || '').toString().replace(/\D/g, "");

  if (!clean) {
    form.value[field + 'Formatted'] = null;
    form.value[field] = null;
    return;
  }

  const num = parseInt(clean, 10) / 100;
  const formatted = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(num);

  form.value[field + 'Formatted'] = formatted;
  form.value[field] = num;
}

const filteredPropertiesRegular = computed(() => {
  return properties.value.filter(property => {
    const matchesOperation = form.value.operation
      ? property.operation === form.value.operation
      : true;

    const matchesCity = form.value.city ? property.city === form.value.city : true;
    const matchesType = form.value.type ? property.type === form.value.type : true;
    const matchesBedrooms = form.value.bedrooms ? property.bedrooms >= form.value.bedrooms : true;
    const matchesPriceMin = form.value.priceMin ? property.price >= form.value.priceMin : true;
    const matchesPriceMax = form.value.priceMax ? property.price <= form.value.priceMax : true;

    return matchesOperation && matchesCity && matchesType && matchesBedrooms && matchesPriceMin && matchesPriceMax;
  });
});

const filteredPropertiesLaunch = computed(() => {
  return properties.value.filter(property => {
    const matchesOperation = form.value.operation
      ? property.operation === form.value.operation
      : true;

    const matchesCity = form.value.city ? property.city === form.value.city : true;
    const matchesType = form.value.type ? property.type === form.value.type : true;
    const matchesBedrooms = form.value.bedrooms ? property.bedrooms >= form.value.bedrooms : true;
    const matchesPriceMin = form.value.priceMin ? property.price >= form.value.priceMin : true;
    const matchesPriceMax = form.value.priceMax ? property.price <= form.value.priceMax : true;

    return matchesOperation && matchesCity && matchesType && matchesBedrooms && matchesPriceMin && matchesPriceMax;
  });
});

function formatPhone(phone) {
  if (!phone) return "";

  const cleaned = ("" + phone).replace(/\D/g, "");

  const match11 = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
  if (match11) return `(${match11[1]}) ${match11[2]}-${match11[3]}`;

  const match10 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
  if (match10) return `(${match10[1]}) ${match10[2]}-${match10[3]}`;

  return phone;
}
</script>

<style scoped>
/* Estilos mantidos do código anterior */
.n-select,
.n-button,
.n-slider {
  --n-border-radius: 10px !important;
  --n-height: 42px !important;
}

.n-button.n-button--primary-type {
  --n-color: #059669 !important;
  --n-color-hover: #047857 !important;
  --n-color-pressed: #065f46 !important;
  --n-border-color: #059669 !important;
  border-radius: 12px !important;
}

.cardPropertyCarousel :deep(.v-carousel__controls) {
  /* CHAVE: Força os bullets a ficarem DENTRO da imagem, 16px acima do fundo */
  bottom: 16px !important;
  top: auto !important;
  /* Anula qualquer posicionamento superior */
  padding: 2px 8px !important;
  background: transparent !important;
  height: 18px;
  z-index: 10 !important;
}

/* 2. Bolinhas (Bullets) de Paginação */
.cardPropertyCarousel :deep(.v-btn--icon.v-btn--size-small) {
  background-color: #d1d5db !important;
  height: 8px !important;
  width: 8px !important;
  margin: 0 4px;
  border-radius: 50%;
  color: transparent !important;
  padding: 0 !important;
  min-width: 8px !important;
  opacity: 1 !important;
}

.cardPropertyCarousel :deep(.v-btn--active.v-btn--size-small) {
  background-color: #1583d4 !important;
  border: none;
}

/* 3. Setas de Navegação (Navigation Arrows) */
.cardPropertyCarousel :deep(.v-btn--icon.v-btn--size-default) {
  background-color: rgba(0, 0, 0, 0.3) !important;
  color: white !important;
  opacity: 0.7;
  height: 30px !important;
  width: 30px !important;
  border-radius: 50% !important;
  transition: opacity 0.3s, background-color 0.3s;
}

/* Efeito Hover na Seta */
.cardPropertyCarousel :deep(.v-btn--icon.v-btn--size-default:hover) {
  opacity: 1 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Seta Desativada */
.cardPropertyCarousel :deep(.v-btn--disabled) {
  opacity: 0.3 !important;
  background-color: rgba(0, 0, 0, 0.1) !important;
}

/* Novos estilos para a seção de corretores */
.broker-card {
  width: 256px;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE e Edge */
  scrollbar-width: none;
  /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari e Opera */
}

.animate-scroll-brokers {
  animation: scroll-left linear infinite;
  animation-duration: 20s;
  /* Ajuste a velocidade aqui */
}

.text-shadow-white {
  text-shadow:
    -2px -2px 2px rgba(255, 255, 255, 0.7),
    2px -2px 2px rgba(255, 255, 255, 0.7),
    -2px 2px 2px rgba(255, 255, 255, 0.7),
    2px 2px 2px rgba(255, 255, 255, 0.7);
}


@keyframes scroll-left {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
</style>